import { render, staticRenderFns } from "./MarzipanoBubbleHotspot.vue?vue&type=template&id=dbce8f5c&scoped=true&"
import script from "./MarzipanoBubbleHotspot.vue?vue&type=script&lang=js&"
export * from "./MarzipanoBubbleHotspot.vue?vue&type=script&lang=js&"
import style0 from "./MarzipanoBubbleHotspot.vue?vue&type=style&index=0&id=dbce8f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbce8f5c",
  null
  
)

export default component.exports